export default {
  meta: {
    title: '日报管理',
    parentPath: 'BOT配置',
    breadcrumbs: ['BOT配置', '日报管理'],
  },
};
